import { render, staticRenderFns } from "./CommissionsPastFutureTotalizer.vue?vue&type=template&id=dc4a0c0e&scoped=true"
import script from "./CommissionsPastFutureTotalizer.vue?vue&type=script&lang=js"
export * from "./CommissionsPastFutureTotalizer.vue?vue&type=script&lang=js"
import style0 from "./CommissionsPastFutureTotalizer.vue?vue&type=style&index=0&id=dc4a0c0e&prod&lang=scss"
import style1 from "./CommissionsPastFutureTotalizer.vue?vue&type=style&index=1&id=dc4a0c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4a0c0e",
  null
  
)

export default component.exports